module.exports = __webpack_public_path__ + "static/img/dwf.878f8e6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon_suffix/dwf.png
// module id = HPBB
// module chunks = 53